export default function SyntagePrivateIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.4"
        d="M10.4902 2.22859L5.50016 4.09859C4.35016 4.52859 3.41016 5.88859 3.41016 7.11859V14.5486C3.41016 15.7286 4.19016 17.2786 5.14016 17.9886L9.44016 21.1986C10.8502 22.2586 13.1702 22.2586 14.5802 21.1986L18.8802 17.9886C19.8302 17.2786 20.6102 15.7286 20.6102 14.5486V7.11859C20.6102 5.88859 19.6702 4.52859 18.5202 4.09859L13.5302 2.22859C12.6802 1.91859 11.3202 1.91859 10.4902 2.22859Z"
        fill="#4F55FD"
      />
      <path
        d="M11.9002 11.3012H12.0002C13.1502 11.2612 14.0502 10.3312 14.0602 9.17125C14.0602 7.99125 13.1002 7.03125 11.9202 7.03125C10.7402 7.03125 9.78016 7.99125 9.78016 9.17125C9.80016 10.3212 10.7002 11.2612 11.9002 11.3012ZM14.1902 13.4122C12.9802 12.6122 11.0202 12.6122 9.80016 13.4122C9.24016 13.7922 8.91016 14.3323 8.91016 14.8923C8.91016 15.4622 9.23016 15.9822 9.80016 16.3622C10.4102 16.7622 11.2002 16.9722 11.9902 16.9722C12.7802 16.9722 13.5802 16.7722 14.1802 16.3622C14.7402 15.9822 15.0702 15.4423 15.0702 14.8822C15.0802 14.3122 14.7602 13.7922 14.1902 13.4122Z"
        fill="#4F55FD"
      />
    </svg>
  );
}
